import axios from 'axios';
import { toast } from 'react-toastify';

import { ErrorMessage } from '@shared/components/Toast/ErrorMessage/ErrorMessage.tsx';

export function renderErrorToastNotification(error: Error) {
  const axiosError = axios.isAxiosError(error);

  if (axiosError) {
    const apiError = 'response' in error && error.response && 'data' in error.response && error.response.data;

    if (apiError) {
      return toast.error(<ErrorMessage error={apiError?.i18n?.key} />);
    }
  }
}
